// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function openGalleryFromImage(event) {
  const magnifier = event.target.closest('.product-media-container')?.querySelector('.magnifier-open');
  if (!magnifier) return;

  if (typeof window.openProductGallery === 'function') {
    event.preventDefault();
    event.stopPropagation();
    window.openProductGallery(magnifier);
  } else {
    // Allow document-level delegation in fancybox-loader to see the click.
    window.setTimeout(() => magnifier.click(), 0);
  }
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      openGalleryFromImage(event);
    };
    // ADA: keydown to control image magnify
    image.addEventListener('keydown', function(e) {
      if(e.key == 'Enter' || e.key == ' ') {
        e.preventDefault();
        e.stopPropagation();
        this.click();
      }
    });
  });
}
function bindZoomHandlers() {
  enableZoomOnHover(2);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindZoomHandlers);
} else {
  bindZoomHandlers();
}

(function () {
  let handlersBound = false;
  let interactionTimeout;

  function humanInteraction() {
    if (!handlersBound) {
      bindZoomHandlers();
      handlersBound = true;
      clearTimeout(interactionTimeout);
    }
  }

  document.addEventListener('click', humanInteraction);
  document.addEventListener('touchstart', humanInteraction, { passive: true });

  interactionTimeout = setTimeout(function () {
    if (!handlersBound) {
      humanInteraction();
    }
  }, 40000);
})();
